import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import VideoContext from "../../context/video/videoContext";
const AddNew = (props) => {
  const videoContext = useContext(VideoContext);
  const newTag = useRef("");
  const [lec, setLec] = useState({
    name: "",
    description: "",
    tags: [],
    prof: "",
    type: "profs",
    branch: props.branch,
    course: props.course,
    year: props.year,
    subject: props.sub,
    id: props.id,
    url: "",
  });

  const { name, description, prof, url, tags } = lec;
  const onChange = (e) => {
    setLec({ ...lec, [e.target.name]: e.target.value });
  };

  const clearCurrentClass = () => {
    setLec({
      name: "",
      description: "",
      prof: "",
      tags: [],
      type: "profs",
      branch: props.branch,
      course: props.course,
      year: props.year,
      subject: props.sub,
      id: props.id,
      url: "",
    });
  };

  const addTag = (e) => {
    let inp = e.target.value;
    let lastChar = inp.substring(inp.length - 1);
    if (lastChar === " " && inp !== " ") {
      inp = inp.slice(0, -1);
      setLec({ ...lec, tags: [...tags, inp] });
      newTag.current.value = "";
    }
  };

  const deleteTag = (e) => {
    tags.splice(e.target.name, 1);
    setLec({ ...lec, tags: tags });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    videoContext.addLecture(lec);
    clearCurrentClass();
  };
  return (
    <Fragment>
      <button
        type='button'
        className='btn btn-block btn-dark slantfont mt-2'
        data-toggle='modal'
        data-target='#staticBackdrop'
        onClick={clearCurrentClass}
      >
        Add New Lecture{" "}
      </button>

      <div
        className='modal fade'
        id='staticBackdrop'
        data-backdrop='static'
        data-keyboard='false'
        tabindex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title upperfont size09' id='staticBackdropLabel'>
                Add Lecture Details
              </h5>
              <button
                type='button'
                className='close btn btn-outline-danger p-2 m-2 slantfont'
                data-dismiss='modal'
                aria-label='Close'
              >
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              <form>
                <div className='form-group fontcool'>
                  <label for='inputEmail4'>Subject</label>
                  <input
                    type='text'
                    className='form-control simplefont'
                    id='inputEmail4'
                    placeholder='Please select subject first...'
                    name='name'
                    value={props.sub}
                    disabled
                  />
                </div>

                <div className='form-row'>
                  <div className='form-group col-md-6 fontcool'>
                    <label for='inputEmail4'>Title</label>
                    <input
                      type='text'
                      className='form-control simplefont'
                      id='inputEmail4'
                      placeholder='Title of lecture...'
                      name='name'
                      value={name}
                      onChange={onChange}
                      required
                    />
                  </div>
                  <div className='form-group col-md-6 fontcool'>
                    <label for='inputPassword4'>Presenter</label>
                    <input
                      type='text'
                      name='prof'
                      className='form-control simplefont'
                      id='inputPassword4'
                      placeholder='Professor...'
                      value={prof}
                      onChange={onChange}
                      required
                    />
                  </div>
                </div>
                <div className='form-group fontcool'>
                  <label for='inputAddress'>Description</label>
                  <textarea
                    rows='4'
                    className='form-control simplefont'
                    id='inputAddress'
                    name='description'
                    onChange={onChange}
                    value={description}
                    placeholder='Topics covered in this lecture'
                  ></textarea>
                </div>
                <div className='form-group fontcool'>
                  <label for='inputAddress2'>Url</label>
                  <input
                    type='text'
                    className='form-control simplefont'
                    id='inputAddress2'
                    value={url}
                    onChange={onChange}
                    required
                    name='url'
                    placeholder='Google ID'
                  />
                  <small id='emailHelp' class='form-text text-muted simplefont'>
                    Google drive id, picked from the address bar when video is
                    Opened in new window{" "}
                  </small>
                </div>
                <div className='form-group fontcool'>
                  <label for='inputAddress2'>Tags : </label>

                  {tags &&
                    tags.map((item, index) => (
                      <input
                        type='button'
                        name={index}
                        value={item}
                        className='simplefont col-2 badge-pill bg-dark rounded-pill text-light mx-auto'
                        aria-label='Close'
                        onClick={deleteTag}
                      />
                    ))}
                  <div className='input-group mb-3'>
                    <input
                      ref={newTag}
                      onChange={addTag}
                      type='text'
                      className='form-control simplefont  text-center'
                      placeholder='Add tags and press space'
                    />{" "}
                  </div>
                </div>
                <button
                  type='submit'
                  className='btn btn-outline-success btn-block'
                  onClick={onSubmit}
                >
                  Add
                </button>
              </form>
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-secondary'
                data-dismiss='modal'
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddNew;
